import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { html } from '@resn/gozer-core';
import { isUndefined } from 'underscore';

import './index.scss';

@componentMixin(DomComponentMixin)
class Indicator extends Component {
    options = {
        template: () => html`
            <div class="header__indicator indicator">
                <div class="indicator__l">
                    <div class="part__inner" data-ui="part-inner-l">
                        <span class="indicator__bg"></span>
                    </div>
                </div>
                <div class="indicator__r" data-ui="part-r">
                    <div class="part__inner" data-ui="part-inner-r">
                        <span class="indicator__bg"></span>
                    </div>
                </div>
            </div>
        `,
    };

    props = {
        v: 0,
        w: 300,
    };

    async onSetup() {}
    onVisible() {
        this.props.v = true;
    }
    offVisible() {
        this.transformTo({ translate: this.props.translate, width: 26, opacity: 0 });
    }

    setV(v) {
        this.el.style.visibility = v ? 'visible' : 'hidden';
    }

    transformTo({ translate, width, opacity } = {}) {
        const x = translate - this.props.w * 0.5;
        const xInner = -(width - this.props.w) * 0.5;

        this.el.style.transform = `translate3d(${x}px, 0px, 0px)`;
        this.el.style.opacity = isUndefined(opacity) ? 1 : opacity;

        this.ui['part-inner-l'].style.transform = `translate3d(${xInner}px, 0px, 0px)`;
        this.ui['part-inner-r'].style.transform = `translate3d(${xInner}px, 0px, 0px)`;

        this.props.translate = translate;
    }
}
export default Indicator;
